import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import { useMutation } from 'react-apollo';
import {
  ReportModalContentContainer,
  ReportModalHeader,
  ModalContent,
  ReportModalButtons,
  StyledTextArea,
} from './style';
import { StyledButtonFilled } from '../Button';
import { sendReportMutation } from '../../shared/graphql/mutations/report/commitReport';
import { client } from '../../shared/graphql';

const DATA_TEST_PRE = 'components-modals-ReportModal-';
const ReportModalContent = props => {
  const { relativeId, type, link, emailContent, closeModal } = props;
  const [textValue, setTextValue] = useState('');
  const [sendReport, { data }] = useMutation(sendReportMutation, { client });
  const onReport = () => {
    sendReport({
      variables: {
        report: {
          content: {
            body: textValue,
          },
          relativeId,
          type,
          link,
          emailContent: {
            ...emailContent,
            reason: textValue,
          },
        },
      },
    });
  };
  useEffect(() => {
    if (textValue && data) {
      const result = data?.commitReport;
      const kind = result ? 'success' : 'error';
      const notificationType = ['error', 'success'].includes(kind)
        ? kind
        : 'info';
      notification[notificationType]({
        duration: 3,
        className: 'notification-antd-crimsom-community',
        message: result
          ? 'Report Send!'
          : "We weren't able to save these changes. Try again?",
        description: result
          ? 'Report Send!'
          : "We weren't able to save these changes. Try again?",
      });
      if (result) {
        closeModal();
      }
    }
  }, [data, textValue]);
  return (
    <ReportModalContentContainer>
      <ReportModalHeader>Report</ReportModalHeader>
      <ModalContent>
        <StyledTextArea
          data-testid={`${DATA_TEST_PRE}TextArea`}
          placeholder="What would you like to report?"
          rows={8}
          allowClear
          value={textValue}
          onChange={e => setTextValue(e.target.value)}
        />
      </ModalContent>
      <ReportModalButtons>
        <StyledButtonFilled
          onClick={() => onReport()}
          data-testid={`${DATA_TEST_PRE}Report`}
        >
          REPORT
        </StyledButtonFilled>
      </ReportModalButtons>
    </ReportModalContentContainer>
  );
};

export default ReportModalContent;
